import { Controller } from "@hotwired/stimulus";
import SearchSerializer from "../utilities/search_serializer";

export default class extends Controller {
  static values = { resultsUrl: String, filterData: Object };
  static targets = ['results', 'loading', 'keyword', 'technologiesContainer'];

  connect() {
    this.defaults = this.filterDataValue;
    this.debounceTimer = null;

    this.serializer = new SearchSerializer({
      arrayKeys: { technologies: Number }
    });

    this.searchDefaults = {
      technologies: [],
      view: 'all',
      letter: null
    };

    var rawParams = this.serializer.readFromHash();
    this.search = Object.assign(
      {},
      JSON.parse(JSON.stringify(this.searchDefaults)),
      this.serializer.deserialize(rawParams, this.searchDefaults)
    );

    this._renderTechnologies();

    if (this.hasKeywordTarget && this.search.q) {
      this.keywordTarget.value = this.search.q;
    }

    this.element.querySelectorAll('[data-cloak]').forEach(function(el) {
      el.removeAttribute('data-cloak');
      el.style.display = '';
    });

    this._syncHashAndFetch();
  }

  keywordInput(event) {
    var self = this;
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(function() {
      self.search.q = event.target.value || '';
      self._syncHashAndFetch();
    }, 400);
  }

  clearKeyword() {
    this.search.q = '';
    if (this.hasKeywordTarget) this.keywordTarget.value = '';
    this._syncHashAndFetch();
  }

  setLetter(event) {
    event.preventDefault();
    this.search.letter = event.currentTarget.dataset.letter || null;
    this._syncHashAndFetch();
  }

  clearLetter(event) {
    event.preventDefault();
    this.search.letter = null;
    this._syncHashAndFetch();
  }

  toggleView() {
    this.search.view = this.search.view === 'members' ? 'all' : 'members';
    this._syncHashAndFetch();
  }

  resetFilters(event) {
    if (event) event.preventDefault();
    this.search = JSON.parse(JSON.stringify(this.searchDefaults));
    if (this.hasKeywordTarget) this.keywordTarget.value = '';
    this._recheckTechnologies();
    this._syncHashAndFetch();
  }

  onTechnologyChange(event) {
    var id = parseInt(event.target.value, 10);
    var arr = this.search.technologies;
    if (event.target.checked) {
      if (arr.indexOf(id) === -1) arr.push(id);
    } else {
      this.search.technologies = arr.filter(function(v) { return v !== id; });
    }
    this._syncHashAndFetch();
  }

  _syncHashAndFetch() {
    var serialized = this.serializer.serialize(this.search, this.searchDefaults);
    this.serializer.writeToHash(serialized);

    this._showLoading(true);

    var params = window.location.hash.replace(/^#\??/, '');
    var url = this.resultsUrlValue + '?' + params;

    var self = this;
    fetch(url, { headers: { 'Accept': 'text/html' } })
      .then(function(r) { return r.text(); })
      .then(function(html) {
        if (self.hasResultsTarget) {
          self.resultsTarget.innerHTML = html;
          self.resultsTarget.style.display = '';
        }
        self._showLoading(false);
      })
      .catch(function(err) {
        console.error('Results fetch failed:', err);
        self._showLoading(false);
      });
  }

  _showLoading(show) {
    if (this.hasLoadingTarget) {
      this.loadingTarget.style.display = show ? '' : 'none';
    }
    if (this.hasResultsTarget) {
      this.resultsTarget.style.display = show ? 'none' : '';
    }
  }

  _renderTechnologies() {
    if (!this.hasTechnologiesContainerTarget) return;
    var self = this;
    var html = (this.defaults.technologies || []).map(function(tech) {
      var checked = self.search.technologies.indexOf(tech.id) !== -1 ? 'checked' : '';
      return '<li><div class="checkbox-line-dark">' +
        '<input type="checkbox" id="technology-' + tech.id + '" value="' + tech.id + '" ' +
        'data-action="change->organization-search#onTechnologyChange" ' + checked + '>' +
        '<label for="technology-' + tech.id + '">' + tech.name + '</label></div></li>';
    }).join('');
    this.technologiesContainerTarget.innerHTML = html;
  }

  _recheckTechnologies() {
    if (!this.hasTechnologiesContainerTarget) return;
    var self = this;
    this.technologiesContainerTarget.querySelectorAll('input[type=checkbox]').forEach(function(cb) {
      cb.checked = self.search.technologies.indexOf(parseInt(cb.value, 10)) !== -1;
    });
  }
}
